<template>
  <v-container pa-0>
  <v-layout class="bdy" pa-0 row wrap >
    <v-flex fluid xs12  >
        <div class="title pl-2 pt-4 white--text">My Timeline</div>  
    </v-flex>
    <v-flex fluid xs12 fill-height=true  >
        <v-card color="primary lighten-1" >
            
        <v-card-text class="box pl-5" >
            <ul >
                <template v-for="(t,tindex) in timeline">
                    <template  v-for="(v, vindex) in t.values"  >
                <li v-bind:key="'li' + tindex + vindex">
                        <div v-if="vindex===0" class="time" v-bind:key="'divd' + tindex + vindex">
                            
                            <span v-bind:key="'spanb' + tindex + vindex">{{getShortDate(t.key)}}</span>
                            <span></span>
                        </div>                       
                        <span v-bind:key="'span' + tindex + vindex">
                            <v-icon class="tlicon" v-if="v.type==='chat'"  color="white">forum</v-icon>
                            <v-icon class="tlicon" v-else-if="v.type==='post'" color="white">format_quote</v-icon>
                            <v-icon class="tlicon" v-else-if="v.type==='payment'" color="white">monetization_on</v-icon>
                            <v-icon class="tlicon" v-else-if="v.type==='checkin'" color="white">location_on</v-icon>
                            <v-icon class="tlicon" v-else-if="v.type==='gallery'" color="white">add_a_photo</v-icon>
                            <v-icon class="tlicon" v-else-if="v.type==='linkedin'" color="white">fab fa-linkedin</v-icon>
                            <v-icon class="tlicon" v-else-if="v.type==='verify'" color="white">fab fa-linkedin</v-icon>
                            <v-icon class="tlicon" v-else-if="v.type==='register'" color="white">person_add</v-icon>
                            <v-icon class="tlicon" v-else color="white">bubble_chart</v-icon>
                        </span>
                        <div class="subheading" v-bind:key="'diva' + tindex + vindex">{{v.name}}</div>
                        <div v-if="v.type==='chat'"  v-bind:key="'divb' + tindex + vindex">
                            <div v-if="v.scope==='line'" class="chat-text">
                                Wrote <v-icon>format_quote</v-icon><em>{{text_truncate(v.text)}}</em><v-icon>format_quote</v-icon> in your Line Chat - {{v.line}}                                
                            </div>
                            <div v-else-if="v.scope==='member'" class="chat-text">
                                Wrote <v-icon>format_quote</v-icon><em>{{text_truncate(v.text)}}</em><v-icon>format_quote</v-icon> in your private chat between  {{v.chatname}}
                            </div>     
                            <div v-else-if="v.scope==='group'" class="chat-text">
                                Wrote <v-icon>format_quote</v-icon><em>{{text_truncate(v.text)}}</em><v-icon>format_quote</v-icon> in the group chat,  {{v.chatname}}
                            </div>                                                     
                        </div>
                        <div v-else-if="v.type==='payment'" class="chat-text" v-bind:key="'divb' + tindex + vindex">
                                {{v.text}}
                        </div>
                        <div v-else-if="v.type==='postnew'" class="chat-text" v-bind:key="'divb' + tindex + vindex">
                                {{v.text}}
                        </div>
                        <div v-else-if="v.type==='postcomment'" class="chat-text" v-bind:key="'divb' + tindex + vindex">
                                {{text_truncate(v.text)}}
                        </div>    
                        <div v-else-if="v.type==='checkin'" class="chat-text" v-bind:key="'divb' + tindex + vindex">
                                Checked In...<span v-if="v.placename"> {{v.placename}} at </span> {{text_truncate(v.text)}} <b><em>until {{v.expiringdatetime.split('T')[1]}}</em></b>
                        </div>  
                        <div v-else-if="v.type==='gallery'" class="chat-text" v-bind:key="'divb' + tindex + vindex">
                                Uploaded a photo to the gallery <v-icon small>add_a_photo</v-icon>
                        </div>                                                                   
                        <div v-else-if="v.type==='linkedin'" class="chat-text" v-bind:key="'divb' + tindex + vindex">
                                Synced their profile with LinkedIn career information <v-icon small>fab fa-linkedin</v-icon>
                        </div>   
                        <div v-else-if="v.type==='verify'" class="chat-text" v-bind:key="'divb' + tindex + vindex">
                                 {{v.text}} <v-icon small>verified_user</v-icon>
                        </div>       
                        <div v-else-if="v.type==='register'" class="chat-text" v-bind:key="'divb' + tindex + vindex">
                                 {{v.text}} <v-icon small>person_add</v-icon>
                        </div>                                                                                                                                                   
                        <div v-else class="chat-text" v-bind:key="'divb' + tindex + vindex">
                                {{v.text}}
                        </div>    
                        
                        <div class="name" v-bind:key="'divc' + tindex + vindex">
                            <v-layout> 
                                                                        
                            <v-flex xs8> 
                            {{v.datetime.split('T')[1]}} 
                            </v-flex>
                            <v-flex xs3>
                            </v-flex>
                            <v-flex xs1> 
                            <v-icon color="white">chevron_right</v-icon>
                            </v-flex>
                            
                        </v-layout>
                        </div>
                        

                    

                </li>
                    </template>
                </template>
            </ul>            
        </v-card-text>
        </v-card>
    </v-flex>
  </v-layout>
  </v-container>
</template>

<script>

import moment from 'moment'


  export default {
    data () {
        return {   
            DATEFORMAT_PARSE: "YYYY-MM-DD",
            DATEFORMAT_OUTPUT: "MMM Do",           
        }
    },      
    computed: {
      myColor () {
         return this.$store.getters.myColor
      },            
      user () {
        return this.$store.getters.user
      },
      timeline () {
          return this.$store.getters.timeline
      },      
      member () {
          return this.$store.getters.member
      }
    },
    methods: {
        getShortDate: function (dt){
            return moment(dt, this.DATEFORMAT_PARSE).format(this.DATEFORMAT_OUTPUT).toUpperCase()
        },
        text_truncate: function(str) {
            var length = 100;
            var ending = '...';

            if (str.length > length) {
                return str.substring(0, length - ending.length) + ending;
            } else {
                return str
            }
        }        
    }    
  }
</script>

<style>

.bdy{
    margin: 0;
    padding: 0;
    background-color:#7E57C2; /*purple*/
    font-family: arial
}
.chat-text{
color:black;
background-color:transparent;
font-size:12px;

}

.social{
  position: absolute;
  top:0;
  left:80%;
  padding: 10px;
  font-size: 110%;
  text-transform: capitalize;
  color:#fff;
  font-weight: 700;
  background-color:rgba(250,250,250,0.3);
  width:120px;
  text-align:center;
  z-index:2;
  line-height:35px
}

.social a{
  text-decoration: none;
  color:#333
}
.social a:after{
  content:" ?????????? ";
  display:block;
  color:#fff;
}

.social a:last-of-type:after{content:""}
/*

.box{
    margin:0 5px;
    height: 630px;
    overflow: hidden;
    padding: 0px 0 5px 40px
}
*/
.box{
    margin:0 5px;
    height: -webkit-fill-available;
    overflow: auto;
    padding: 0px 0 5px 55px
}

.box ul{
    list-style-type: none;
    margin: 0;
    padding: 0;
    position: relative;
    transition: all 0.5s linear;
    top:0
}

.box ul:last-of-type{top:80px}

.box ul:before{
    content: "";
    display: block;
    width: 0;
    height: 100%;
    border:1px dashed #fff;
    position: absolute;
    top:0;
    left:30px
}

.box ul li{
    margin: 20px 60px 60px;
    position: relative;
    padding: 10px 20px;
    background:rgba(255, 255, 255, 0.3);
    color:#fff;
    border-radius: 10px;
    line-height: 20px;
    width: 75%
}



.box ul li > span{
    content: "";
    display: block;
    width: 0;
    height: 100%;
    border:1px solid #fff;
    position: absolute;
    top:0;
    left:-30px
}

/*
.box ul li > span:before,.box ul li > span:after{
    content: "";
    display: block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background:#7E57C2; purple
    border:2px solid #fff;
    position: absolute;
    left:-7.5px
}
*/


.box ul li > span:before,.box ul li > span:after{
    content: "";
    display: block;
    background:#7E57C2; /*purple*/
    position: absolute;
    border-radius: 50%;
}


.tlicon{
    margin-left:-25px;
}
.box ul li > span:before{top:-10px}
.box ul li > span:after{top:95%}

.box .title{
    text-transform: uppercase;
    font-weight: 700;
    margin-bottom: 5px;

}

.box .subheading{
    text-transform: uppercase;
    font-weight: 700;
    margin-bottom: 5px;

}

.box .info:first-letter{text-transform: capitalize;line-height: 1.7}

.box .name{
    margin-top: 10px;
    text-transform: capitalize;
    font-style: italic;
    text-align: right;
    margin-right: 20px
}


.box .time span{
    position: absolute;
    left: -100px;
    color:#fff;
    font-size:80%;
    font-weight: bold;
}
.box .time span:first-child{top:-16px}
.box .time span:last-child{top:94%}


.arrow{
    position: absolute;
    top: 105%;
    left: 22%;
    cursor: pointer;
  height:20px;
  width:20px
}

.arrow:hover{
    -webkit-animation: arrow 1s linear infinite;
       -moz-animation: arrow 1s linear infinite;
         -o-animation: arrow 1s linear infinite;
            animation: arrow 1s linear infinite;
}

.box ul:last-of-type .arrow{
    position: absolute;
    top: 105%;
    left: 22%;
    transform: rotateX(180deg);
    cursor: pointer;
}

svg{
    width: 20px;
    height: 20px
}

@keyframes arrow{
    0%,100%{
        top:105%
    }
    50%{
        top:106%
    }
}

@-webkit-keyframes arrow{
    0%,100%{
        top:105%
    }
    50%{
        top:106%
    }
}

@-moz-keyframes arrow{
    0%,100%{
        top:105%
    }
    50%{
        top:106%
    }
}

@-o-keyframes arrow{
    0%,100%{
        top:105%
    }
    50%{
        top:106%
    }
}

</style>